import { enqueueNotification, SnackbarItem } from '@core/features/snackbar';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { heroApiService } from '@services/.';
import { ExtraReducer, getSideEffectState } from '@utils/.';
import { LocationReducerProps } from '../type';
import { RootState } from '@core/configureStore';
import { fetchCurrentUser } from '@core/features/auth/thunks';

export const updateReviewUrl = createAsyncThunk(
  'business/updateReviewUrl',
  async (reviewUrl: string, thunkApi) => {
    try {
      const {
        auth: { user },
      } = thunkApi.getState() as RootState;
      if (!user) throw new Error('No user found');
      const selectedLocation = user.selected_location;

      await heroApiService.updateReviewUrl(selectedLocation.location_id, reviewUrl);
      await thunkApi.dispatch(fetchCurrentUser());
      thunkApi.dispatch(
        enqueueNotification({
          name: `Update Review Url of location ${selectedLocation.title}`,
          description: 'Successfully updated Google Review Url',
          type: 'Success',
        } as SnackbarItem)
      );
    } catch (error: any) {
      thunkApi.dispatch(
        enqueueNotification({
          name: 'Failed to update reviewUrl',
          description: 'There was error updating Google Review Url. Please try again',
          type: 'Error',
        } as SnackbarItem)
      );
      throw new Error(error);
    }
  }
);

const [fulfilled, pending, rejected] = getSideEffectState(updateReviewUrl);

export const updateReviewUrlReducer = {
  [fulfilled]: (state, action) => {
    state.isLoading = false;
  },
  [rejected]: (state, action) => {
    state.isLoading = false;
  },
  [pending]: (state, action) => {
    state.isLoading = true;
  },
} as ExtraReducer<LocationReducerProps>;
